// config.js
const config = {
	appName: 'The Tasting Alliance',
	version: '1.1.0',

};

export default config;